import { Config } from '../config/envConfig';
import { isTruthy } from '@quyva/common';

export const getUrl = (fullUrl) => {
    const useSecuredConnection = isTruthy(Config.USE_SECURED_CONNECTION);
    if (useSecuredConnection) {
        return fullUrl.replace('http:', 'https:');
    }
    return fullUrl;
};
